import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AngularFireMessaging } from '@angular/fire/messaging';
import { AngularFireModule } from "@angular/fire";
import { app } from "firebase/app";

@Injectable()
export class MessagingService {

    currentMessage = new BehaviorSubject<any>(null);

    constructor(
        private angularFireMessaging:AngularFireMessaging
    ) {

    }

    requestPermission() {
        app().installations().getId().then(id => {
            console.log(`Installation Id:`, id)
            localStorage.setItem('InstanceId', id);
        })
    }

    listenIdChange() {
        app().installations().onIdChange(id => {
            console.log(`Installation Id change:`, id)
            localStorage.setItem('InstanceId', id);
        })
    }

    receiveMessaging(){
        this.angularFireMessaging.messages.subscribe(payload => {
            console.log("New message received", payload)
            this.currentMessage.next(payload);
        })
    }

}
